<template>
  <div class="wrap">
    <div class="tab-wrap">
      <el-radio-group v-model="tabValue" size="small" @change="changeTab">
        <el-radio-button label="1">发货单记录</el-radio-button>
        <el-radio-button label="2">退货单记录</el-radio-button>
      </el-radio-group>
    </div>
    <div class="content-wrap">
      <el-row class="search-wrap">
        <el-input
          style="width: 220px"
          v-model="conditions.receiptSn"
          class="mr10"
          size="small"
          placeholder="请输入订单号"
          clearable
        ></el-input>
        <el-select
          v-show="tabValue == '1'"
          v-model="conditions.orderState"
          class="mr10"
          size="small"
          placeholder="请选择订单状态"
          clearable
        >
          <el-option
            v-for="item in stateList"
            :key="item.value"
            v-bind="item"
          ></el-option>
        </el-select>
        <el-input
          style="width: 220px"
          v-show="tabValue == '1'"
          v-model="conditions.deliverSn"
          class="mr10"
          size="small"
          placeholder="请输入发货单号"
          clearable
        ></el-input>
        <el-input
          style="width: 220px"
          v-show="tabValue == '2'"
          v-model="conditions.omsReturnId"
          class="mr10"
          size="small"
          placeholder="请输入退货单号"
          clearable
        ></el-input>
        <el-select
          v-model="conditions.type"
          class="mr10"
          size="small"
          placeholder="请选择推送状态"
          v-if="tabValue == '2'"
          clearable
        >
          <el-option
            v-for="item in pushStateList"
            :key="item.value"
            v-bind="item"
          ></el-option>
        </el-select>
        <el-input
          style="width: 220px"
          v-show="tabValue == '1'"
          v-model="conditions.expressOrderSn"
          class="mr10"
          size="small"
          placeholder="请输入快递单号"
          clearable
        ></el-input>
        <el-input
          style="width: 220px"
          v-model="conditions.thirdNo"
          class="mr10"
          size="small"
          placeholder="请输入三方系统单号"
          clearable
        ></el-input>
        <el-date-picker
          size="small"
          class="mr10"
          v-model="dataRange"
          type="datetimerange"
          start-placeholder="推送开始时间"
          end-placeholder="推送结束时间"
          :default-time="['00:00:00', '23:59:59']"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
        >
        </el-date-picker>
        <el-button @click="handleSearch" size="small" type="primary"
          >搜索</el-button
        >
      </el-row>
      <el-row v-show="tabValue === '1'">
        <el-table :data="sendTableDate" stripe size="small">
          <el-table-column
            label="订单号"
            prop="receiptSn"
            align="cener"
          ></el-table-column>
          <el-table-column
            label="订单状态"
            prop="orderNo"
            align="cener"
          ><template slot-scope="scope">
            {{stateList.find(item => item.value === scope.row.orderState)?stateList.find(item => item.value === scope.row.orderState).label:''}}
            </template></el-table-column>
          <el-table-column
            label="确认发货时间"
            prop="takeTime"
            align="cener"
          ></el-table-column>
          <el-table-column
            label="发货单号"
            prop="deliverSn"
            align="cener"
          ></el-table-column>
          <!-- <el-table-column
            label="推送状态"
            prop="orderNo"
            align="cener"
          ></el-table-column> -->
          <el-table-column
            label="快递单号"
            prop="expressOrderSn"
            align="cener"
          ></el-table-column>
          <el-table-column
            label="三方订单号"
            prop="thirdNo"
            align="cener"
          ></el-table-column>
          <el-table-column
            label="推送时间"
            prop="sendTime"
            align="cener"
          ></el-table-column>
          <el-table-column label="操作" align="cener">
            <template slot-scope="scope">
              <el-button type="text" @click="handleShowDetail(scope.row)"
                >查看单据详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row v-show="tabValue === '2'">
        <el-table :data="returnTableDate" stripe size="small">
          <el-table-column
            label="订单号"
            prop="receiptSn"
            align="cener"
          ></el-table-column>
          <el-table-column
            label="退货单号"
            prop="omsReturnId"
            align="cener"
          ></el-table-column>
          <el-table-column
            label="推送状态"
            prop="type"
            align="cener"
          >
          <template slot-scope="scope">
            {{pushStateList.find(item => item.value === scope.row.type)?pushStateList.find(item => item.value === scope.row.type).label:""}}
          </template>
          </el-table-column>
          <el-table-column
            label="三方系统单号"
            prop="thirdNo"
            align="cener"
          ></el-table-column>
          <el-table-column
            label="推送时间"
            prop="sendTime"
            align="cener"
          ></el-table-column>
          <el-table-column label="操作" align="cener">
            <template slot-scope="scope">
              <el-button type="text" @click="handleShowDetail(scope.row)"
                >查看单据详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row type="flex" justify="center" class="mt20">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>
      </el-row>
    </div>



    <!-- 
        订单详情 -- 发货单
     -->
     <el-dialog
      :close-on-click-modal="false"
      :visible.sync="sendDialogVisible"
      width="1200px"
    >
      <div slot="title">
        <span class="mr10">订单详情</span>
        <!-- <span class="form-item-tip" style="color: #fF0000"
          >当前订单状态：{{ orderSta }}</span
        > -->
      </div>
      <div class="content">
        <!-- <div class="progress" v-if="delOrder">
          <el-steps :active="active" align-center>
            <el-step title="创建订单" :description="createOrderTime"></el-step>
            <el-step title="支付订单" :description="payOrderTime"></el-step>
            <el-step
              title="平台配货发货"
              :description="deliverOrderTime"
            ></el-step>
            <el-step title="确认收货" :description="takeOrderTime"></el-step>
            <el-step title="完成评价" :description="pushOrderTime"></el-step>
          </el-steps>
        </div>
        <div class="flex flex-between p20" v-if="delOrder">
          <div>
            <el-button
              :disabled="disabled"
              type="primary"
              size="small"
              @click="openSendDialog(detailsOrder.order.deliveryType)"
              >去发货</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="sureArrive"
              :disabled="delivery"
              >确认送达</el-button
            >
            <el-button
              v-if="
                detailsOrder.orderStatus[detailsOrder.orderStatus.length - 1]
                  .orderStatus === 'createOrder'
              "
              type="primary"
              size="small"
              @click="openCancleOrderDialog"
              >取消订单</el-button
            >
          </div>
        </div> -->
        <ul class="info-list">
          <li class="mb20">
            <div class="flex flex-wrap">
              <div class="title mr10">基本信息</div>
              <el-tag
                size="mini"
                effect="plain"
                color="#FFEEF6"
                v-if="detailsOrder.order.isOverseas === 'yes'"
                >海外购</el-tag
              >
            </div>
            <div class="mb20">
              <el-table stripe border :data="[detailsOrder.order]" size="small">
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="receiptSn"
                  label="订单号"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="发货单流水号"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberName"
                  label="会员姓名"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberMobile"
                  label="会员手机号"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="payMode"
                  label="支付方式"
                >
                  <template slot-scope="scope">
                    <span
                      class="status danger"
                      v-if="scope.row.payMode === 'no_pay'"
                      >未支付</span
                    >
                    <span
                      class="status danger"
                      v-if="scope.row.payMode === '0_pay'"
                      >0元订单</span
                    >
                    <span
                      class="status danger"
                      v-if="scope.row.payMode === 'wx_pay'"
                      >微信支付</span
                    >
                    <span
                      class="status danger"
                      v-if="scope.row.payMode === 'ali_pay'"
                      >支付支付</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="orderSource"
                  label="订单来源"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.orderSource === 'wxShop'"
                      >微店订单</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="orderType"
                  label="订单类型"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.orderType === 'wshop'">微店订单</span>
                    <span v-if="scope.row.orderType === 'ptdd'">拼团订单</span>
                    <span v-if="scope.row.orderType === 'kjdd'">砍价订单</span>
                    <span v-if="scope.row.orderType === 'mshd'">秒杀订单</span>
                    <span v-if="scope.row.orderType === 'smg_faceToFace'"
                      >代客下单-当面收款</span
                    >
                    <span v-if="scope.row.orderType === 'smg_netPush'"
                      >代客下单-网络推送</span
                    >
                    <span v-if="scope.row.orderType === 'dhdd'">兑换订单</span>
                    <span v-if="scope.row.orderType === 'integral_order'"
                      >积分兑换订单</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="mb20">
              <el-table stripe border :data="[detailsOrder.order]" size="small">
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="deliveryType"
                  label="配送方式"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.deliveryType === 'mdzt'"
                      >门店自提</span
                    >
                    <span v-if="scope.row.deliveryType === 'kdfh'"
                      >快递发货</span
                    >
                    <span v-if="scope.row.deliveryType === 'tcps'"
                      >同城配送</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="detailsOrder.order.deliveryType === 'mdzt'"
                  header-align="center"
                  align="center"
                  prop="billNo"
                  label="提货单号"
                ></el-table-column>
                <el-table-column
                  v-else
                  header-align="center"
                  align="center"
                  prop="expressOrderSn"
                  label="物流单号"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="自动确认收货时间"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="shopName"
                  label="指定信息"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="活动信息"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="orderRemark"
                  label="订单备注"
                ></el-table-column>

                <!-- <el-table-column
                  width="150"
                  header-align="center"
                  align="center"
                  label="操作"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="small"
                      type="text"
                      @click="editOrderRemark(scope.row)"
                      >编辑备注</el-button
                    >
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
          </li>
          <li class="mb20">
            <div class="title">收货人信息</div>
            <el-table stripe border :data="[detailsOrder.order]" size="small">
              <el-table-column
                header-align="center"
                align="center"
                prop="receiverName"
                label="收货人"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiverMobile"
                label="手机号码"
              ></el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="邮政编码"
              ></el-table-column> -->
              <el-table-column
                header-align="center"
                align="center"
                prop="deliveryAddress"
                label="收货地址"
              >
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.deliveryProvince
                    }}{{ scope.row.deliveryAddress }}</span
                  >
                </template>
              </el-table-column>
              <!-- <el-table-column
                width="150"
                header-align="center"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    type="text"
                    @click="editReceiver(scope.row)"
                    >修改收货人信息</el-button
                  >
                </template>
              </el-table-column> -->
            </el-table>
          </li>
          <li class="mb20">
            <div class="flex flex-between">
              <div class="title">商品信息</div>
              <!-- <div
                class="flex flex-end item-center"
                v-if="
                  detailsOrder.order.payMode !== 'no_pay' &&
                    isBtn('tuikuan:false')
                "
              >
                <span class="pointer mr10" @click="batchReturn">
                  <span class="hmicon icon-jianhuopeihuo"> </span>
                  批量退款
                </span>
              </div> -->
            </div>

            <el-table
              border
              :data="detailsOrder.orderGoods"
              size="small"
              :row-class-name="tableRowClassName"
            >
            <!-- 
              @selection-change="getCheckedReturn"
             -->
              <!-- <el-table-column
                type="selection"
                width="50"
                header-align="center"
                align="center"
                :selectable="checkSelectable"
                v-if="
                  detailsOrder.order.payMode !== 'no_pay' &&
                    isBtn('tuikuan:false')
                "
              >
              </el-table-column> -->
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsImg"
                label="商品图片"
              >
                <template slot-scope="scope">
                  <div>
                    <div
                      class="flex flex-center item-center"
                      v-if="scope.row.returnType !== 'no'"
                    >
                      <!-- 仅退款 -->
                      <img
                        v-if="scope.row.refundReturnType === 'money'"
                        style="width:100px;height:100px"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/81d2994f64c85809bf951f14fd56ecc.png"
                        alt=""
                      />

                      <!-- 退货退款 -->
                      <img
                        v-if="scope.row.refundReturnType === 'refund'"
                        style="width:100px;height:100px"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/8088827e177ba800a9eba2c17e295c8.png"
                        alt=""
                      />

                      <!-- 退运费 -->
                      <img
                        v-if="scope.row.refundReturnType === 'deliver'"
                        style="width:100px;height:100px"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/9a0ad12b4cead9d04371c126a61d5d5.png"
                        alt=""
                      />
                    </div>

                    <img
                      class="warning-tuikuan"
                      v-show="scope.row.returnType === 'yes'"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                      alt=""
                    />
                    <img
                      class="warning-tuikuan"
                      v-show="scope.row.returnType === 'doing'"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                      alt=""
                    />
                    <div
                      class="flex flex-center item-center"
                      :class="
                        scope.row.returnType !== 'no' ? 'only-tuikuan' : ''
                      "
                    >
                      <div>
                        <img
                          style="width:100px;height:100px;"
                          v-if="scope.row.goodsImg"
                          :src="scope.row.goodsImg"
                          alt=""
                        />
                        <div style="width:100%">
                          <el-tag
                            style="width:100%"
                            size="mini"
                            effect="plain"
                            type="success"
                            v-if="scope.row.isGift === 'gift'"
                            >赠 品</el-tag
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="商品名称/品牌"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.spuName }}</p>
                  <p>品牌: {{ scope.row.brandName }}</p>
                  <el-tag type="warning"
                    >{{
                      scope.row.spuType === "virtual" ? "虚拟" : "实物"
                    }}商品</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="价格/货号"
              >
                <template slot-scope="scope">
                  <p>价格: {{ scope.row.totalPrice }}</p>
                  <p>货号: {{ scope.row.goodsSn }}</p>
                  <p>条码: {{ scope.row.barCode }}</p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="净重/毛重"
              >
                <template slot-scope="scope">
                  <p v-if="scope.row.netWeight">
                    净重: {{ scope.row.netWeight }}
                  </p>
                  <p v-if="scope.row.grossWeight">
                    毛重: {{ scope.row.grossWeight }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="specIdGroupName"
                label="规格"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsNum"
                label="数量"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="totalPrice"
                label="小计"
              >
                <template slot-scope="scope">
                  <p>
                    {{ (scope.row.totalPrice * scope.row.goodsNum).toFixed(2) }}
                  </p>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div
                    v-if="
                      detailsOrder.order.payMode !== 'no_pay' &&
                        isBtn('tuikuan:false')
                    "
                  >
                    <el-button
                      v-if="
                        (scope.row.spuType === 'virtual' &&
                          scope.row.memberLaunchRefund === 'yes') ||
                          scope.row.spuType !== 'virtual'
                      "
                      :disabled="scope.row.returnType !== 'no'"
                      size="small"
                      class="danger"
                      type="text"
                      @click="refund(scope.row)"
                      >退款</el-button
                    >
                  </div>
                </template>
              </el-table-column> -->
            </el-table>
          </li>
          <li class="mb20">
            <div class="title">费用信息</div>
            <el-table stripe border :data="[detailsOrder.order]" size="small">
              <el-table-column
                header-align="center"
                align="center"
                prop="totalPrice"
                label="商品合计"
              >
                <template slot-scope="scope">
                  <p>￥{{ scope.row.totalPrice }}</p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="taxFee"
                label="税费"
                v-if="detailsOrder.order.isOverseas === 'yes'"
              >
                <template slot-scope="scope">
                  <p>￥{{ scope.row.taxFee }}</p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="deliverMoney"
                label="运费"
              >
                <template slot-scope="scope">
                  <p>￥{{ scope.row.deliverMoney }}</p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="deliverCouponMoney"
                label="运费券抵扣"
              >
                <template slot-scope="scope">
                  <span class="status primary"
                    >-￥{{ scope.row.deliverCouponMoney }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="couponMoney"
                label="优惠券"
                width="220"
              >
                <template slot-scope="scope">
                  <div
                    class="primary"
                    v-for="(v, i) in scope.row.orderCouponInfoModels"
                    :key="i"
                  >
                    {{ v.ruleName }} {{ v.couponCode }}
                  </div>
                  <div class="status primary">
                    -￥{{ scope.row.couponMoney }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="activeMoney"
                label="积分抵扣"
                v-if="detailsOrder.order.orderType === 'integral_order'"
              >
                <template slot-scope="scope">
                  <span class="status danger"
                    >-￥{{ scope.row.activeMoney }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="activeMoney"
                label="活动优惠"
                v-else
              >
                <template slot-scope="scope">
                  <span class="status danger"
                    >-￥{{ scope.row.activeMoney }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="actuallyPrice"
                label="实付金额"
              >
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.orderType === 'integral_order'"
                    class="status danger"
                  >
                    <span v-if="scope.row.actuallyPrice"
                      >¥{{ scope.row.actuallyPrice }}+</span
                    >
                    <span>{{ scope.row.integralPoint }}积分 </span>
                  </div>
                  <span v-else class="status danger"
                    >¥{{ scope.row.actuallyPrice }}</span
                  >
                </template>
                <!-- <template slot-scope="scope">
                  <span class="status danger"
                    >￥{{ scope.row.actuallyPrice }}</span
                  >
                </template> -->
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="payPrice"
                label="应付金额"
              >
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.orderType === 'integral_order'"
                    class="status danger"
                  >
                    <span v-if="scope.row.payPrice"
                      >¥{{ scope.row.payPrice }}+</span
                    >
                    <span>{{ scope.row.integralPoint }}积分 </span>
                  </div>
                  <span v-else class="status danger"
                    >¥{{ scope.row.payPrice }}</span
                  >
                </template>
                <!-- <template slot-scope="scope">
                  <span class="status danger">￥{{ scope.row.payPrice }}</span>
                </template> -->
              </el-table-column>
            </el-table>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="sendDialogVisible=false" size="small" type="primary">关闭</el-button>
      </span>
    </el-dialog>



    <!-- 
        退货单详情
     -->
     
    <el-dialog
      :close-on-click-modal="false"
      width="95%"
      :visible.sync="pushDialogVisible"
    >
      <div slot="title">
        <span class="mr10">订单详情</span>
        <!-- <span class="form-item-tip" style="color: #fF0000"
          >当前订单状态：{{ orderSta }}</span
        > -->
      </div>
      <div class="content">
        <div class="flex mt10">
          <ul class="info-list flex-1" style="width:50%">
            <div style="paddingLeft:10px">
              <li class="mb20">
                <div class="title">基本信息</div>
                <div class="mb20">
                  <el-table
                    stripe
                    border
                    :data="[detailsOrder.order]"
                    size="small"
                  >
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="receiptSn"
                      label="订单号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="spuName"
                      label="发货单流水号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="memberMobile"
                      label="会员手机号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="payMode"
                      label="支付方式"
                    >
                      <template slot-scope="scope">
                        <span
                          class="status danger"
                          v-if="scope.row.payMode === 'no_pay'"
                          >未支付</span
                        >
                        <span
                          class="status danger"
                          v-if="scope.row.payMode === '0_pay'"
                          >0元订单</span
                        >
                        <span
                          class="status danger"
                          v-if="scope.row.payMode === 'wx_pay'"
                          >微信支付</span
                        >
                        <span
                          class="status danger"
                          v-if="scope.row.payMode === 'ali_pay'"
                          >支付支付</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="orderSource"
                      label="订单来源"
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.orderSource === 'wxShop'"
                          >微店订单</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="orderType"
                      label="订单类型"
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.orderType === 'wshop'"
                          >微店订单</span
                        >
                        <span v-if="scope.row.orderType === 'ptdd'"
                          >拼团订单</span
                        >
                        <span v-if="scope.row.orderType === 'kjdd'"
                          >砍价订单</span
                        >
                        <span v-if="scope.row.orderType === 'mshd'"
                          >秒杀订单</span
                        >
                        <span v-if="scope.row.orderType === 'smg_faceToFace'"
                          >代客下单-当面收款</span
                        >
                        <span v-if="scope.row.orderType === 'smg_netPush'"
                          >代客下单-网络推送</span
                        >
                        <span v-if="scope.row.orderType === 'dhdd'"
                          >兑换订单</span
                        >
                        <span v-if="scope.row.orderType === 'integral_order'"
                          >积分兑换订单</span
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="mb20">
                  <el-table
                    stripe
                    border
                    :data="[detailsOrder.order]"
                    size="small"
                  >
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="deliveryType"
                      label="配送方式"
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.deliveryType === 'mdzt'"
                          >门店自提</span
                        >
                        <span v-if="scope.row.deliveryType === 'kdfh'"
                          >快递发货</span
                        >
                        <span v-if="scope.row.deliveryType === 'tcps'"
                          >同城配送</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-if="detailsOrder.order.deliveryType === 'mdzt'"
                      header-align="center"
                      align="center"
                      prop="billNo"
                      label="提货单号"
                    ></el-table-column>
                    <el-table-column
                      v-else
                      header-align="center"
                      align="center"
                      prop="expressOrderSn"
                      label="物流单号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="spuName"
                      label="自动确认收货时间"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="shopName"
                      label="指定信息"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="orderRemark"
                      label="订单备注"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="spuName"
                      label="活动信息"
                    ></el-table-column>
                  </el-table>
                </div>
              </li>
              <li class="mb20">
                <div class="title">收货人信息</div>
                <el-table
                  stripe
                  border
                  :data="[detailsOrder.order]"
                  size="small"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="receiverName"
                    label="收货人"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="receiverMobile"
                    label="手机号码"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="邮政编码"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="deliveryAddress"
                    label="收货地址"
                  >
                    <template slot-scope="scope">
                      <span
                        >{{ scope.row.deliveryProvince
                        }}{{ scope.row.deliveryAddress }}</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </li>
              <li class="mb20">
                <div class="title">商品信息</div>
                <el-table
                  border
                  :data="detailsOrder.orderGoods"
                  size="small"
                  :row-class-name="tableRowClassNames"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsImg"
                    label="商品图片"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <div>
                        <div
                          class="flex flex-center item-center"
                          v-if="scope.row.returnType !== 'no'"
                        >
                          <!-- 仅退款 -->
                          <img
                            v-if="scope.row.refundReturnType === 'money'"
                            style="width:100px;height:100px"
                            src="https://imgcdn.hemiao100.com/hemiaoBase/81d2994f64c85809bf951f14fd56ecc.png"
                            alt=""
                          />

                          <!-- 退货退款 -->
                          <img
                            v-if="scope.row.refundReturnType === 'refund'"
                            style="width:100px;height:100px"
                            src="https://imgcdn.hemiao100.com/hemiaoBase/8088827e177ba800a9eba2c17e295c8.png"
                            alt=""
                          />

                          <!-- 退运费 -->
                          <img
                            v-if="scope.row.refundReturnType === 'deliver'"
                            style="width:100px;height:100px"
                            src="https://imgcdn.hemiao100.com/hemiaoBase/9a0ad12b4cead9d04371c126a61d5d5.png"
                            alt=""
                          />
                        </div>

                        <img
                          class="warning-tuikuan"
                          v-show="scope.row.returnType === 'yes'"
                          src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                          alt=""
                        />
                        <img
                          class="warning-tuikuan"
                          v-show="scope.row.returnType === 'doing'"
                          src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                          alt=""
                        />
                        <div
                          class="flex flex-center item-center"
                          :class="
                            scope.row.returnType !== 'no' ? 'only-tuikuan' : ''
                          "
                        >
                          <img
                            style="width:100px;height:100px;"
                            v-if="scope.row.goodsImg"
                            :src="scope.row.goodsImg"
                            alt=""
                          />
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="商品名称/品牌"
                  >
                    <template slot-scope="scope">
                      <el-tooltip
                        class="item"
                        :content="scope.row.spuName"
                        placement="top"
                      >
                        <div class="flex item-center">
                          <!-- <span class="pos" v-if="scope.row.createMode">
                          p
                        </span> -->

                          <span class="time flex-1 text-overflow">
                            {{ scope.row.spuName }}
                          </span>
                        </div>
                      </el-tooltip>
                      <div>品牌: {{ scope.row.brandName }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="价格/货号"
                  >
                    <template slot-scope="scope">
                      <p>价格: {{ scope.row.totalPrice }}</p>
                      <p>货号: {{ scope.row.goodsSn }}</p>
                      <p>条码: {{ scope.row.barCode }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="净重/毛重"
                  >
                    <template slot-scope="scope">
                      <p v-if="scope.row.netWeight">
                        净重: {{ scope.row.netWeight }}
                      </p>
                      <p v-if="scope.row.grossWeight">
                        毛重: {{ scope.row.grossWeight }}
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="specIdGroupName"
                    label="规格"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsNum"
                    label="数量"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="totalPrice"
                    label="小计"
                  >
                    <template slot-scope="scope">
                      <p>
                        {{
                          (scope.row.totalPrice * scope.row.goodsNum).toFixed(2)
                        }}
                      </p>
                    </template>
                  </el-table-column>
                </el-table>
              </li>
              <li class="mb20">
                <div class="title">费用信息</div>
                <el-table
                  stripe
                  border
                  :data="[detailsOrder.order]"
                  size="small"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="totalPrice"
                    label="商品合计"
                  >
                    <template slot-scope="scope">
                      <p>￥{{ scope.row.totalPrice }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="deliverMoney"
                    label="运费"
                  >
                    <template slot-scope="scope">
                      <p>￥{{ scope.row.deliverMoney }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="deliverCouponMoney"
                    label="运费券抵扣"
                  >
                    <template slot-scope="scope">
                      <span class="status danger"
                        >-￥{{ scope.row.deliverCouponMoney }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="packageMoney"
                    label="包装费"
                  >
                    <template slot-scope="scope">
                      <p>￥{{ scope.row.packageMoney }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="couponMoney"
                    label="优惠券"
                  >
                    <template slot-scope="scope">
                      <span class="status danger"
                        >-￥{{ scope.row.couponMoney }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="activeMoney"
                    label="积分抵扣"
                    v-if="detailsOrder.order.orderType === 'integral_order'"
                  >
                    <template slot-scope="scope">
                      <span class="status danger"
                        >-￥{{ scope.row.activeMoney }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="activeMoney"
                    label="活动优惠"
                    v-else
                  >
                    <template slot-scope="scope">
                      <span class="status danger"
                        >-￥{{ scope.row.activeMoney }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="activeMoney"
                    label="金豆"
                    v-if="
                      detailsOrder.order.otherPayInfo &&
                        detailsOrder.order.otherPayInfo.length
                    "
                  >
                    <template slot-scope="scope">
                      <div v-for="(v, i) in scope.row.otherPayInfo" :key="i">
                        <div v-if="v.financeCode === 'goldBean'">
                          金豆：已用{{ v.financeValue }}{{ v.relName }}抵用
                          <span class="danger">-￥{{ v.currencyAmount }}</span>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="actuallyPrice"
                    label="实付金额"
                  >
                    <template slot-scope="scope">
                      <div
                        v-if="scope.row.orderType === 'integral_order'"
                        class="status danger"
                      >
                        <span v-if="scope.row.actuallyPrice"
                          >¥{{ scope.row.actuallyPrice }}+</span
                        >
                        <span>{{ scope.row.integralPoint }}积分 </span>
                      </div>
                      <span v-else class="status danger"
                        >¥{{ scope.row.actuallyPrice }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="payPrice"
                    label="应付金额"
                  >
                    <template slot-scope="scope">
                      <div
                        v-if="scope.row.orderType === 'integral_order'"
                        class="status danger"
                      >
                        <span v-if="scope.row.payPrice"
                          >¥{{ scope.row.payPrice }}+</span
                        >
                        <span>{{ scope.row.integralPoint }}积分 </span>
                      </div>
                      <span v-else class="status danger"
                        >¥{{ scope.row.payPrice }}</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </li>
              <li class="mb20">
                <div class="title">操作信息</div>
                <el-table
                  stripe
                  border
                  :data="detailsOrder.orderStatus"
                  size="small"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="operatorAccount"
                    label="操作账号"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="operatorName"
                    label="操作人"
                  >
                    <template slot-scope="scope">
                      <div v-if="scope.row.operatorName === null">
                        {{ scope.row.createBy }}
                      </div>
                      <div v-else>
                        {{ scope.row.operatorName }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="createTime"
                    label="操作时间"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="订单状态"
                  >
                    <template slot-scope="scope">
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'createOrder'"
                        >待付款</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'payOrder'"
                        >待发货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'deliverOrder'"
                        >已发货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'takeOrder'"
                        >已收货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'pushOrder'"
                        >已评价</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'delOrder'"
                        >已取消</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'returnOrder'"
                        >有退货退款</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'rejectOrder'"
                        >驳回申请</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="付款状态"
                  >
                    <template slot-scope="scope">
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'createOrder'"
                        >未付款</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'payOrder'"
                        >已付款</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'deliverOrder'"
                        >已付款</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'takeOrder'"
                        >已付款</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'pushOrder'"
                        >已付款</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'delOrder'"
                        >已取消</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="spuName"
                    label="发货状态"
                  >
                    <template slot-scope="scope">
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'createOrder'"
                        >未发货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'payOrder'"
                        >未发货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'deliverOrder'"
                        >已发货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'takeOrder'"
                        >已发货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'pushOrder'"
                        >已发货</span
                      >
                      <span
                        class="status blue"
                        v-if="scope.row.orderStatus === 'delOrder'"
                        >已取消</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="remark"
                    label="备注"
                  ></el-table-column>
                  <!-- <el-table-column
                  header-align="center"
                  align="center"
                  label="操作"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <el-button size="small" type="text" @click="beizhu(scope.row)"
                        >添加备注</el-button
                      >
                    </div>
                  </template>
                </el-table-column> -->
                </el-table>
              </li>
            </div>
          </ul>
          <ul class="info-list flex-1" style="width:50%">
            <div style="padding:0 10px">
              <li>
                <div class="progress mb20" v-if="delOrder">
                  <el-steps :active="active" align-center>
                    <el-step
                      title="发起申请"
                      :description="returnSendTime"
                    ></el-step>
                    <el-step
                      title="核定信息"
                      :description="returnConfirmTime"
                    ></el-step>
                    <el-step
                      v-if="returnInfo.status !== 8"
                      title="退货/退款"
                      :description="refundTime"
                    ></el-step>
                    <el-step
                      title="驳回"
                      v-if="returnInfo.status == 8"
                    ></el-step>
                  </el-steps>
                  <!-- <el-steps :active="active" align-center>
                  <el-step title="创建订单" :description="createOrderTime"></el-step>
                  <el-step title="支付订单" :description="payOrderTime"></el-step>
                  <el-step
                    title="平台配货发货"
                    :description="deliverOrderTime"
                  ></el-step>
                  <el-step title="确认收货" :description="takeOrderTime"></el-step>
                  <el-step title="完成评价" :description="pushOrderTime"></el-step>
                </el-steps> -->
                </div>
              </li>
              <li class="mb20">
                <div class="title">
                  <div class="expressSn flex flex-column" v-if="returnGoods && returnGoods.length && returnGoods.some(item => item.expressSn)">
                    <div v-for="(v, i) in returnGoods" :key="i">
                      <div v-if="v.expressSn">
                        退货快递单号：{{v.expressSn}} <span @click="orderDetail(v)">查看物流》</span>
                      </div>
                    </div>
                  </div>
                  退款单
                </div>
                <div class="mb20 flex-1">
                  <el-table
                    border
                    :data="returnGoods"
                    :span-method="objectSpanMethod"
                    size="small"
                    @row-click="openDetails"
                    highlight-current-row
                    :row-class-name="tableRowClassName"
                  >
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnSn"
                      label="退货单号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="spuName"
                      label="商品名称"
                    >
                      <template slot-scope="scope">
                        <el-tooltip
                          class="item"
                          :content="scope.row.spuName"
                          placement="top"
                        >
                          <div class="flex item-center">
                            <!-- <span class="pos" v-if="scope.row.createMode">
                            p
                          </span> -->
                            <span class="time flex-1 text-overflow">
                              {{ scope.row.spuName }}
                            </span>
                          </div>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnSendTime"
                      label="退单时间"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="status"
                      label="退款状态"
                    >
                      <template slot-scope="scope">
                        <span class="danger" v-if="scope.row.status === 1"
                          >待审核</span
                        >
                        <span class="danger" v-if="scope.row.status === 2"
                          >已审核</span
                        >
                        <span class="danger" v-if="scope.row.status === 3"
                          >已退货待退款</span
                        >
                        <span class="blue" v-if="scope.row.status === 4"
                          >已退款</span
                        >
                        <span class="gray" v-if="scope.row.status === 5"
                          >待确认</span
                        >
                        <span class="danger" v-if="scope.row.status === 8"
                          >已驳回</span
                        >
                        <span class="gray" v-if="scope.row.status === 9"
                          >已取消</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnAmount"
                      label="退商品"
                    >
                      <template slot-scope="scope">
                        <span class="danger"
                          >¥{{ scope.row.returnAmount }}</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="confirmReturnAmount"
                      label="商品核定"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-if="scope.row.status === 1"
                          clearable
                          type="txt"
                          @mousewheel.prevent.native
                          @input="
                            filterGt0OrFixed2(
                              'confirmReturnAmount',
                              scope.$index
                            )
                          "
                          style="width:100%;"
                          v-model.trim="scope.row.confirmReturnAmount"
                          size="small"
                        ></el-input>
                        <div v-else>
                          <span class="danger"
                            >¥{{ scope.row.confirmReturnAmount }}</span
                          >
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnDeliverMoney"
                      label="退运费"
                    >
                      <template slot-scope="scope">
                        <span class="danger"
                          >¥{{ scope.row.returnDeliverMoney }}</span
                        >
                      </template>
                    </el-table-column>

                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="confirmReturnDeliverMoney"
                      label="运费核定"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-if="scope.row.status === 1"
                          clearable
                          type="txt"
                          @mousewheel.prevent.native
                          @input="
                            filterGt0OrFixed2(
                              'confirmReturnDeliverMoney',
                              scope.$index
                            )
                          "
                          style="width:100%;"
                          v-model.trim="scope.row.confirmReturnDeliverMoney"
                          size="small"
                        ></el-input>
                        <div v-else>
                          <span class="danger"
                            >¥{{ scope.row.confirmReturnDeliverMoney }}</span
                          >
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnPackageMoney"
                      label="退包装费"
                    >
                      <template slot-scope="scope">
                        <span class="danger"
                          >¥{{ scope.row.returnPackageMoney }}</span
                        >
                      </template>
                    </el-table-column>

                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="confirmReturnPackageMoney"
                      label="包装费核定"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-if="scope.row.status === 1"
                          clearable
                          type="txt"
                          @mousewheel.prevent.native
                          @input="
                            filterGt0OrFixed2(
                              'confirmReturnPackageMoney',
                              scope.$index
                            )
                          "
                          style="width:100%;"
                          v-model.trim="scope.row.confirmReturnPackageMoney"
                          size="small"
                        ></el-input>
                        <div v-else>
                          <span class="danger"
                            >¥{{ scope.row.confirmReturnPackageMoney }}</span
                          >
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="prepayMoney"
                      label="退储值卡"
                      v-if="!queryConfigFlag"
                    >
                      <template slot-scope="scope">
                        <span class="danger">¥{{ scope.row.prepayMoney }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnPrepayCardMoney"
                      label="退储值卡"
                      v-if="queryConfigFlag"
                    >
                      <template slot-scope="scope">
                        <span class="danger"
                          >¥{{ scope.row.returnPrepayCardMoney }}</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="confirmReturnPrepayCardMoney"
                      label="核定退储值卡"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-if="scope.row.status === 1"
                          clearable
                          type="txt"
                          @mousewheel.prevent.native
                          @input="
                            filterGt0OrFixed2(
                              'confirmReturnPrepayCardMoney',
                              scope.$index
                            )
                          "
                          style="width:100%;"
                          v-model.trim="scope.row.confirmReturnPrepayCardMoney"
                          size="small"
                        ></el-input>
                        <div v-else>
                          <span class="danger"
                            >¥{{ scope.row.confirmReturnPrepayCardMoney }}</span
                          >
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnIntegral"
                      label="退积分"
                      v-if="isShowReturnIntegral"
                    >
                      <template slot-scope="scope">
                        <span class="danger">{{
                          scope.row.returnIntegral
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="核定退积分"
                      v-if="isShowReturnIntegral"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <div v-if="active < 2">
                          <el-input
                            v-if="scope.row.confirmReturnIntegral"
                            clearable
                            type="txt"
                            @mousewheel.prevent.native
                            @input="
                              filterGt0OrFixed2(
                                'confirmReturnIntegral',
                                scope.$index
                              )
                            "
                            style="width:100%;"
                            v-model.trim="scope.row.confirmReturnIntegral"
                            size="small"
                          ></el-input>
                          <div v-else>
                            <span class="danger"
                              >¥{{ scope.row.confirmReturnIntegral }}</span
                            >
                          </div>
                        </div>
                        <div v-else class="danger">
                          {{ scope.row.confirmReturnIntegral }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-if="activeTab == 0"
                      label="操作"
                      header-align="center"
                      align="center"
                      width="200"
                    >
                      <template slot-scope="scope">
                        <div
                          class="flex flex-center"
                          v-if="scope.row.status === 1 && isBtn('tongyi:false')"
                        >
                          <el-button
                            size="small"
                            type="text"
                            @click="consent(scope.$index)"
                            >同意退款</el-button
                          >
                          <el-button
                            size="small"
                            type="text"
                            v-if="refundAgain !== 'yes'"
                            @click="bohui(scope.$index)"
                            >驳回</el-button
                          >
                          <el-button
                            size="small"
                            type="text"
                            class="blue"
                            v-if="returnType==='deliver' && scope.row.returnAmount==0"
                            @click="applyReturnGoods(scope.row,scope.$index)"
                            >申请退商品</el-button
                          >
                        </div>
                        <div
                          class="flex flex-center"
                          v-if="scope.row.status === 2 && isBtn('queren:false')"
                        >
                          <el-button
                            size="small"
                            type="text"
                            @click="consent(scope.$index)"
                            >确认退款</el-button
                          >
                          <el-button
                            size="small"
                            type="text"
                            @click="bohui(scope.$index)"
                            >驳回</el-button
                          >
                        </div>
                        <div
                          class="flex flex-center"
                          v-if="scope.row.status === 4"
                        >
                          <el-button
                            size="small"
                            type="text"
                            @click="jixu(scope.$index)"
                            >继续退款</el-button
                          >
                        </div>
                        <div v-if="scope.row.status === 5">
                          <el-button
                            size="small"
                            type="text"
                            @click="undo(scope.row)"
                            >撤销</el-button
                          >
                          <el-button
                              size="small"
                              type="text"
                              @click="makeSenseDialog(scope.row)"
                              v-if="isBtn('makeSense:false')"
                          >代确认退款</el-button
                          >
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="mb20">
                  <div class="title">操作记录</div>
                  <el-table stripe border :data="refundRecordList" size="small">
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="receiverName"
                      label="操作状态"
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.operationType === 'apply'"
                          >申请退款</span
                        >
                        <span v-else-if="scope.row.operationType === 'agree'"
                          >同意退款</span
                        >
                        <span v-else-if="scope.row.operationType === 'refuse'"
                          >驳回申请</span
                        >
                        <span v-else-if="scope.row.operationType === 'pay'"
                          >确认退款</span
                        >
                        <span
                          v-else-if="scope.row.operationType === 'backApply'"
                          >后台发起</span
                        >
                        <span
                          v-else-if="scope.row.operationType === 'agreeAgain'"
                          >再次同意</span
                        >
                        <span v-else-if="scope.row.operationType === 'payAgain'"
                          >再次确认</span
                        >
                        <span v-else-if="scope.row.operationType === 'applyReturnGoods'"
                          >申请退商品</span
                        >
                        <span v-else-if="scope.row.operationType === 'makeSense'"
                        >代确认退款</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnAmount"
                      label="金额/积分"
                    >
                      <template slot-scope="scope">
                        <span class="danger"
                          >¥{{ scope.row.returnAmount }} /
                          {{ scope.row.returnIntegral || 0 }}积分</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnDeliverMoney"
                      label="运费"
                    >
                      <template slot-scope="scope">
                        <span class="danger"
                          >¥{{ scope.row.returnDeliverMoney }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnPackageMoney"
                      label="包装费"
                    >
                      <template slot-scope="scope">
                        <span class="danger"
                          >¥{{ scope.row.returnPackageMoney }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="returnPrepayCardMoney"
                      label="储值卡"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="operationRemark"
                      label="操作备注"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="operationTime"
                      label="操作时间"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="operationName"
                      label="操作人"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </li>
            </div>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="pushDialogVisible=false" size="small" type="primary">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 
<script>
import { mapGetters } from "vuex";
import { getLoginUser } from "@/utils/auth";
import moment from "moment";
export default {
  name: "",
  components: {},
  mixins: [],
  props: {},
  computed: mapGetters([
    "orderReturnList",
    "detailsorderReturn",
    "salesChannels",
    "allMallGoodsList",
    "shopModelList",
    "microShopStoreList",
    "detailsOrder",
    "dkMicroShopStoreList",
  ]),
  watch: {},
  data() {
    return {
      tabValue: "1",
      conditions: {
        receiptSn: "", //  订单号
        deliverSn: "", //  发货单号
        storeCode: "", //  供应商编号
        expressOrderSn: "", //  物流单号
        thirdNo: "", //  写入三方系统成功返回的订单号
        createStartTime: "", //  推送开始时间
        createEndTime: "", //  推送结束时间
        orderState: "",
        type: ""
      },
      stateList: [
        {
          label: "待付款",
          value: "createOrder",
        },
        {
          label: "待发货",
          value: "payOrder",
        },
        {
          label: "待收货",
          value: "deliverOrder",
        },
        {
          label: "退款",
          value: "returnOrder",
        },
        {
          label: "取消订单",
          value: "delOrder",
        },
        {
          label: "确认收货",
          value: "takeOrder",
        },
        {
          label: "完成评论",
          value: "pushOrder",
        },
      ],
      dataRange: [
        moment().format("YYYY-MM-DD 00:00:00"),
        moment().format("YYYY-MM-DD 23:59:59")
      ],
      sendTableDate: [{}],
      returnTableDate: [{}],
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      nowRow: null,
      receiptSn: "",
      returnSn: "",
      orderRefundId: "",
      returnType: "",
      orderGoodsId: "",
      orderId: "",
      sendDialogVisible: false,
      pushDialogVisible: false,
      refundRecordList: [],
      returnInfo: {},
      active: "",
      show: "",
      refundTime: "",
      returnSendTime: "",
      returnConfirmTime: "",
      delOrder: "",
      disabled: "",
      delivery: "",
      orderSta: "",
      createOrderTime: "",
      payOrderTime: "",
      deliverOrderTime: "",
      takeOrderTime: "",
      pushOrderTime: "",
      useReturnDeliverMoney: "",
      ruleFormRetrun: {
        returnType: "",
        returnDeliverMoney: "",
        returnContext: ""
      },
      returnGoods: [],
      activeTab: 1,
      queryConfigFlag: false,
      isShowReturnIntegral: false,
      pushStateList: [
        {
          label: "未发货作废",
          value: "delete"
        },
        {
          label: "已发货发起售后",
          value: "afterSales"
        }
      ]
    };
  },
  created() {
    this.getTableData();
  },
  mounted() {},
  destroyed() {},
  methods: {
    resetPage() {
      this.conditions = {
        receiptSn: "", //  订单号
        deliverSn: "", //  发货单号
        storeCode: "", //  供应商编号
        expressOrderSn: "", //  物流单号
        thirdNo: "", //  写入三方系统成功返回的订单号
        createStartTime: "", //  推送开始时间
        createEndTime: "", //  推送结束时间
        orderState: "",
      };
      this.dataRange = [
        moment().format("YYYY-MM-DD 00:00:00"),
        moment().format("YYYY-MM-DD 23:59:59")
      ]
      this.page = {
        pageNo: 1,
        pageSize: 10,
      };
      this.total = 0;
    },
    /**
     * @desc 切换推送记录类型
     */
    changeTab(val) {
      console.log("---input--", val);
      this.resetPage();
      this.getTableData();
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      // 只合并区域位置
      if (!this.queryConfigFlag) {
        if (columnIndex === 10) {
          const _row = this.rowSpanArr[rowIndex];

          return {
            rowspan: _row, //行
            colspan: 1, //列
          };
        }
      }
    },
    tableRowClassName({ row }) {
      if (row.returnSn === this.returnSn) {
        return "tuikuan";
      }
      return "";
    },
    tableRowClassNames({ row }) {
      if (row.returnType !== "no") {
        return "tuikuan";
      }
      return "";
    },

    getCheckedReturn(selection) {
      this.returnGoods = selection;
    },

    async orderDetail(row) {
      if (row.expressSn) {
        this.expressSn = row.expressSn;
      }
      if (row.expressSenderPhone) {
        this.expressSenderPhone = row.expressSenderPhone;
      } else {
        this.expressSenderPhone = row.memberMobile;
      }
      this.logisticsInfoVisible = true;
      const { storeCode } = getLoginUser();
      const { code, result } = await this.$store.dispatch("getExpressInfo", {
        storeCode,
        expressSn: row.expressSn,
        expressSenderPhone: row.expressSenderPhone,
      });
      if (code === "0") {
        if (result.state === "201") {
          this.$message({
            message: result.message,
            type: "warning",
          });
          return false;
        }
        this.expressInfoResult = result;
      }
    },
    /**
     * @desc 搜索
     */
    handleSearch() {
      this.page.pageNo = 1;
      this.page.pageSize = 10;
      this.getTableData();
    },
    /**
     * @desc 查看单据详情
     */
    handleShowDetail(row) {
      console.log("--row---", row);
      if (this.tabValue == "1") {
        // row = {
        //   pageNo: 0,
        //   pageSize: 15,
        //   orderId: "aabc8671e682451a8a0024f10cb7b853",
        //   createBy: null,
        //   createTime: null,
        //   statusTime: null,
        //   updateBy: null,
        //   updateTime: null,
        //   delFlag: null,
        //   storeCode: "42010216070190",
        //   receiptSn: "wx7214710728946022",
        //   receiptSnList: null,
        //   orderType: "wshop",
        //   totalGoodsNum: 1,
        //   purchaseTime: "2024-03-18 10:29:06",
        //   receiverName: "陈建",
        //   receiverMobile: "13333333333",
        //   totalPrice: null,
        //   payPrice: 3.01,
        //   actuallyPrice: 3.01,
        //   orderRemark: null,
        //   orderState: "payOrder",
        //   payState: "yes",
        //   expressState: null,
        //   expressStarttime: null,
        //   expressEndtime: null,
        //   orderSource: "wxShop",
        //   payMode: "wx_pay",
        //   memberMobile: null,
        //   belongEmployeeId: null,
        //   belongShopId: "42010216070190_4030",
        //   payTime: "2024-03-18 10:29:42",
        //   centerId: "92393a4c1253402793b587622eb712e9",
        //   memberCardId: null,
        //   billNo: "03-7651574318575",
        //   deliveryMsg: null,
        //   deliveryType: "tcps",
        //   cancelMsg: null,
        //   gameId: null,
        //   plusHandled: null,
        //   prepayMoney: 0,
        //   integralPoint: null,
        //   deliverCouponMoney: 0,
        //   deliverSn: null,
        //   couponMoney: 0,
        //   activeMoney: 0,
        //   queryKey: null,
        //   deliveryAddress: "泛海国际SOHO城",
        //   cardType: null,
        //   starTime: null,
        //   endTime: null,
        //   shopName: "469大观店",
        //   typeName: null,
        //   cardTypeName: null,
        //   expressOrderSn: null,
        //   goodsList: null,
        //   couponList: null,
        //   realname: null,
        //   openid: null,
        //   shareType: null,
        //   isDeliver: null,
        //   phone: null,
        //   deliveryProvince: "湖北省武汉市江汉区淮海路299号",
        //   deliveryCity: null,
        //   deliveryDistrict: null,
        //   markupMoney: 0,
        //   isSale: null,
        //   platformId: null,
        //   isHandled: null,
        //   writePosSuccess: null,
        //   shopIds: null,
        //   deliverMoney: 1,
        //   packageMoney: 2,
        //   opeer: null,
        //   printType: "no",
        //   departId: null,
        //   formId: null,
        //   payUrlValue: null,
        //   treeStruct: null,
        //   departName: null,
        //   memberName: null,
        //   shareMemberName: null,
        //   shareMemberMobile: null,
        //   goodsKey: null,
        //   shopPhone: "0871-65355722",
        //   shopAddress: "湖北省武汉市江汉区兴唐街",
        //   shopDetailAddress: null,
        //   sendTime: null,
        //   ruleName: null,
        //   couponCode: null,
        //   serialNumber: null,
        //   shareCenterId: null,
        //   editType: null,
        //   orderCouponInfoModels: null,
        //   orderPromotionRecordId: null,
        //   workNum: null,
        //   isSend: null,
        //   expressQueryId: null,
        //   expressSendMode: null,
        //   packageNum: null,
        //   querySnType: null,
        //   querySnValue: null,
        //   queryGoodsType: null,
        //   queryGoodsValue: null,
        //   queryMemberType: null,
        //   queryMemberValue: null,
        //   queryTimeType: null,
        //   queryTimeValueStart: null,
        //   queryTimeValueEnd: null,
        //   queryOrderSourceType: null,
        //   goodsSource: null,
        //   cardTypeId: null,
        //   supplierId: null,
        //   couponName: null,
        //   expressModelList: null,
        //   ticketId: null,
        //   ifTakeOrder: null,
        //   taxFee: 0,
        //   isOverseas: "no",
        //   exportId: null,
        //   id: null,
        //   oldShopId: null,
        //   orderMode: null,
        //   writePosFailReason: null,
        //   writePosHandleState: null,
        //   categoryId: null,
        //   categoryIds: null,
        //   keyWord: null,
        //   gameName: null,
        //   wechatAvatar: null,
        //   sortNum: null,
        //   otherPayInfo: null,
        //   nickName: null,
        //   queryReceiverKeyWord: null,
        //   sourceId: null,
        //   supplierCode: null,
        //   sourceAppName: null,
        //   paySource: null,
        //   isShop: null,
        //   mdztIsValid: null,
        //   mdztTimeOut: null,
        //   isThirdDelivery: null,
        //   guiderUserName: null,
        //   outTradeNo: null,
        //   appId: null,
        // };
        this.orderId = row.orderId;
        this.receiptSn = row.receiptSn;
        this.sendDialogVisible = true;
        this.details();
      }
      if (this.tabValue == "2") {
        // row = {
        //   pageNo: 0,
        //   pageSize: 15,
        //   orderRefundId: "40537e7c2daf4afb9f3d6379dcee61be",
        //   createBy: null,
        //   createTime: null,
        //   updateBy: null,
        //   updateTime: null,
        //   delFlag: null,
        //   storeCode: null,
        //   receiptSn: "wx8697708573822587",
        //   returnSn: "tkdh7551708574275958",
        //   skuId: null,
        //   goodsSn: "80064482",
        //   barCode: "6972210290387",
        //   goodsNum: null,
        //   categoryId: null,
        //   brandId: null,
        //   totalPrice: null,
        //   payPrice: null,
        //   actuallyPrice: 0.02,
        //   orderId: "170c344be3d2475fbae865adcd18940b",
        //   orderSn: null,
        //   orderGoodsId: "825300c5819c326783699472d4f1757d",
        //   wxshopSkuId: null,
        //   status: 1,
        //   returnNumber: null,
        //   returnIntegral: 0,
        //   returnAmount: 0.02,
        //   returnReason: "不想要了",
        //   confirmReturnAmount: 0.02,
        //   voucher: null,
        //   returnSendTime: "2024-02-22 11:57:56",
        //   returnSendOperator: null,
        //   returnConfirmTime: null,
        //   returnConfirmOperator: null,
        //   confrimExplain: null,
        //   auditTime: null,
        //   auditOperator: null,
        //   refundTime: "2024-02-22 11:57:56",
        //   refundOperator: null,
        //   returnType: "refund",
        //   returnContext: "",
        //   centerId: null,
        //   shopName: "禾苗网销店",
        //   refundMode: null,
        //   supplierCode: null,
        //   queryKey: null,
        //   shopId: "b2d2bd17248b4cb6b175b24664e571ba",
        //   starTime: null,
        //   endTime: null,
        //   spuName: "世喜吸管嘴OMS测试商品",
        //   returnTranslate: null,
        //   goodsImg:
        //     "https://imgcdn.hemiao100.com/42010216070190/mall/2023-08-30/1693379675752-ce33c961-0a0d-4ddf.png?x-oss-process=image/auto-orient,1",
        //   goodsNumber: "2",
        //   specIdGroupName: "",
        //   shopIds: null,
        //   departId: null,
        //   formId: null,
        //   treeStruct: null,
        //   operationRemark: null,
        //   orderDetailsId: null,
        //   returnDeliverMoney: 0,
        //   confirmReturnDeliverMoney: 0,
        //   returnPackageMoney: 0,
        //   confirmReturnPackageMoney: 0,
        //   operationType: null,
        //   deliverMoney: 0,
        //   packageMoney: null,
        //   returnPrepayCardMoney: 0,
        //   confirmReturnPrepayCardMoney: 0,
        //   orderCreateTime: "2024-02-22 11:50:22",
        //   memberMobile: "13545255042",
        //   memberName: "测试用户",
        //   operationName: null,
        //   realname: null,
        //   queryTimeType: null,
        //   returnWritePosStatus: null,
        //   orderGoodsIdList: null,
        //   confirmReturnIntegral: 0,
        //   isConfirm: null,
        //   refundAgain: null,
        //   shareStoreName: null,
        //   supplierName: "",
        //   receiverName: null,
        //   receiverMobile: null,
        //   deliveryAddress: null,
        //   deliveryProvince: null,
        //   expressSn: null,
        //   expressSenderPhone: null,
        //   refundReceiverName: null,
        //   refundReceiverMobile: null,
        //   refundReceiverAddress: null,
        // };
        this.nowRow = row;
        this.receiptSn = row.receiptSn;
        this.returnSn = row.returnSn;
        this.orderRefundId = row.orderRefundId;
        this.returnType = row.returnType;
        this.pushDialogVisible = true;
        this.orderGoodsId = row.orderGoodsId;
        this.orderId = row.orderId;

        this.queryOrderRefundRecord();
        this.details();
      }
    },
    async queryOrderRefundRecord() {
      this.returnReason = {};
      let params = {
        orderRefundId: this.orderRefundId,
      };
      const { result } = await this.$store.dispatch(
        "queryOrderRefundRecordList",
        params
      );
      const { refundRecordModelList, returnInfo } = result;
      this.refundRecordList = refundRecordModelList;
      this.returnInfo = returnInfo;
      if (returnInfo.status === 1) {
        this.active = 1;
        this.disabled = false;
        this.show = false;
        this.refundTime = "";
        this.returnSendTime = returnInfo.returnSendTime;
        // this.orderSta = "发起申请";
      } else if (returnInfo.status === 2) {
        this.active = 2;
        this.disabled = false;
        this.show = true;
        this.returnSendTime = returnInfo.returnSendTime;
        this.refundTime = "";
        this.returnConfirmTime = returnInfo.returnConfirmTime;
        // this.orderSta = "核定信息";
      } else if (returnInfo.status === 3) {
        this.active = 3;
        this.show = true;
        this.returnConfirmTime = returnInfo.returnConfirmTime;
        this.returnSendTime = returnInfo.returnSendTime;
        this.refundTime = returnInfo.refundTime;
        // this.orderSta = "退货/退款";
      } else if (returnInfo.status === 4) {
        this.active = 3;
        this.disabled = true;
        this.returnConfirmTime = returnInfo.returnConfirmTime;
        this.returnSendTime = returnInfo.returnSendTime;
        this.refundTime = returnInfo.refundTime;
        // this.orderSta = "退货/退款";
      } else if (returnInfo.status === 8) {
        this.active = 3;
        this.disabled = true;
        this.returnSendTime = returnInfo.returnSendTime;
        this.returnConfirmTime = returnInfo.returnConfirmTime;
      }
      if (this.returnInfo.returnReason) {
        this.returnReason = JSON.parse(this.returnInfo.returnReason);
        if (this.returnReason.list.length && this.statusList.length) {
          this.returnReason.list.forEach((v) => {
            this.statusList.forEach((o) => {
              if (v.status === o.value) {
                v.statusLabel = o.label;
              }
            });
          });
          this.returnReason.list = JSON.parse(
            JSON.stringify(this.returnReason.list)
          );
        }
        console.log("this.returnReason:", this.returnReason);
      }
    },
    /**
     * @desc 详情 --- 发货单
     */
    details() {
      return this.$store
        .dispatch("detailOrder", {
          orderId: this.orderId,
        })
        .then((res) => {
          let orderSta =
            res.result.orderStatus[res.result.orderStatus.length - 1];
          let flag = false;
          res.result.orderGoods.map((v) => {
            if (v.returnType === "no") {
              flag = true;
            }
          });
          if (flag) {
            let listStatus = [];
            res.result.orderStatus.forEach((v) => {
              if (v.orderStatus !== "returnOrder") {
                listStatus.push(v);
              }
            });
            orderSta = listStatus[listStatus.length - 1];
          }

          if (orderSta.orderStatus === "createOrder") {
            this.active = 1;
            this.delOrder = true;
            this.disabled = true;
            this.delivery = true;
            this.orderSta = "待付款";
          } else if (orderSta.orderStatus === "payOrder") {
            this.active = 2;
            this.delOrder = true;
            this.disabled = false;
            this.delivery = true;
            this.orderSta = "待发货";
          } else if (orderSta.orderStatus === "deliverOrder") {
            this.active = 3;
            this.delOrder = true;
            this.orderSta = "已发货";
            this.delivery = false;
            this.disabled = true;
          } else if (orderSta.orderStatus === "takeOrder") {
            this.active = 4;
            this.delOrder = true;
            this.orderSta = "已收货";
            this.delivery = true;
            this.disabled = true;
          } else if (orderSta.orderStatus === "pushOrder") {
            this.active = 5;
            this.delOrder = true;
            this.orderSta = "已评价";
            this.delivery = true;
            this.disabled = true;
          } else if (orderSta.orderStatus === "delOrder") {
            this.delOrder = false;
            this.orderSta = "已取消";
          } else if (orderSta.orderStatus === "returnOrder") {
            this.delOrder = false;
            this.orderSta = "有退货退款";
          }

          res.result.orderStatus.forEach((v) => {
            if (v.orderStatus === "createOrder") {
              this.createOrderTime = v.createTime;
            }
            if (v.orderStatus === "payOrder") {
              this.payOrderTime = v.createTime;
            }
            if (v.orderStatus === "deliverOrder") {
              this.deliverOrderTime = v.createTime;
            }
            if (v.orderStatus === "takeOrder") {
              this.takeOrderTime = v.createTime;
            }
            if (v.orderStatus === "pushOrder") {
              this.pushOrderTime = v.createTime;
            }
          });
          if (this.tabValue === "1") {
            let returnDeliver = 0;
            res.result.orderGoods.forEach((v) => {
              returnDeliver += v.returnDeliverMoney || 0;
            });
            this.useReturnDeliverMoney = (
              res.result.order.deliverMoney -
              returnDeliver -
              res.result.order.deliverCouponMoney
            ).toFixed(2);
            console.log("useReturnDeliverMoney:", this.useReturnDeliverMoney);
            if (this.useReturnDeliverMoney) {
              this.ruleFormRetrun.returnDeliverMoney = parseFloat(this.useReturnDeliverMoney);
            }
            this.queryShopList();
          } else {
            this.queryReturnGoods();
          }
        });
    },
    async queryReturnGoods() {
      let params = {
        receiptSn: this.receiptSn,
      };

      const { result } = await this.$store.dispatch(
        "queryReturnGoodsList",
        params
      );
      this.returnGoods = result;
      this.returnGoods.forEach((v) => {
        v.prepayMoney = this.detailsOrder.order.prepayMoney;
      });
      this.isShowReturnIntegral =
        this.returnGoods.findIndex((v) => v.returnIntegral) > -1;
      this.getRowSpan();
    },

    queryShopList() {
      this.$store.dispatch("queryShopList", {
        pageNo: 1,
        pageSize: 99999,
      });
    },
    /**
     * @desc 切换展示条数
     */
    handleSizeChange(val) {
      this.page.pageNo = 1;
      this.page.pageSize = val;
      this.getTableData();
    },
    /**
     * @desc 切换页码
     */
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getTableData();
    },
    /**
     * @desc 获取表格数据
     */
    async getTableData() {
      if (this.dataRange && this.dataRange.length > 0) {
        this.conditions.createStartTime = this.dataRange[0];
        this.conditions.createEndTime = this.dataRange[1];
      } else {
        this.conditions.createStartTime = "";
        this.conditions.createEndTime = "";
      }
      const {
        receiptSn,
        deliverSn,
        expressOrderSn,
        thirdNo,
        createStartTime,
        createEndTime,
        orderState,
        omsReturnId,
        type
      } = this.conditions;
      const { storeCode } = getLoginUser();
      if (this.tabValue === "1") {
        const { code, result } = await this.$store.dispatch(
          "omsOrderSendPage",
          {
            pageNo: this.page.pageNo,
            pageSize: this.page.pageSize,
            receiptSn, //  订单号
            deliverSn, //  发货单号
            storeCode,
            expressOrderSn, //  物流单号
            thirdNo, //  写入三方系统成功返回的订单号
            createStartTime, //  推送开始时间
            createEndTime, //  推送结束时间
            orderState,
          }
        );
        if (code === "0") {
          this.total = result.total;
          this.sendTableDate = result.records;
        }
        console.log("---result---", result);
      } else {
        const { code, result } = await this.$store.dispatch(
          "omsOrderRefundInfoPage",
          {
            pageNo: this.page.pageNo,
            pageSize: this.page.pageSize,
            receiptSn, //  订单号
            omsReturnId, //  退货单号
            thirdNo, //  写入三方系统成功返回的订单号
            createStartTime, //  推送开始时间
            createEndTime, //  推送结束时间
            storeCode,
            type
          }
        );

        if (code === "0") {
          this.total = result.total;
          this.returnTableDate = result.records;
        }
        console.log("---result---", result);
      }
    },

    isBtn(code) {
      return this.isShowBtn(code);
    },

    openDetails(row) {
      this.orderGoodsId = row.orderGoodsId;
      this.returnSn = row.returnSn;
      this.receiptSn = row.receiptSn;
      this.orderRefundId = row.orderRefundId;
      this.queryOrderRefundRecord();
    },
    async queryOrderRefundRecord() {
      this.returnReason = {};
      let params = {
        orderRefundId: this.orderRefundId,
      };
      const { result } = await this.$store.dispatch(
        "queryOrderRefundRecordList",
        params
      );
      const { refundRecordModelList, returnInfo } = result;
      this.refundRecordList = refundRecordModelList;
      this.returnInfo = returnInfo;
      if (returnInfo.status === 1) {
        this.active = 1;
        this.disabled = false;
        this.show = false;
        this.refundTime = "";
        this.returnSendTime = returnInfo.returnSendTime;
        // this.orderSta = "发起申请";
      } else if (returnInfo.status === 2) {
        this.active = 2;
        this.disabled = false;
        this.show = true;
        this.returnSendTime = returnInfo.returnSendTime;
        this.refundTime = "";
        this.returnConfirmTime = returnInfo.returnConfirmTime;
        // this.orderSta = "核定信息";
      } else if (returnInfo.status === 3) {
        this.active = 3;
        this.show = true;
        this.returnConfirmTime = returnInfo.returnConfirmTime;
        this.returnSendTime = returnInfo.returnSendTime;
        this.refundTime = returnInfo.refundTime;
        // this.orderSta = "退货/退款";
      } else if (returnInfo.status === 4) {
        this.active = 3;
        this.disabled = true;
        this.returnConfirmTime = returnInfo.returnConfirmTime;
        this.returnSendTime = returnInfo.returnSendTime;
        this.refundTime = returnInfo.refundTime;
        // this.orderSta = "退货/退款";
      } else if (returnInfo.status === 8) {
        this.active = 3;
        this.disabled = true;
        this.returnSendTime = returnInfo.returnSendTime;
        this.returnConfirmTime = returnInfo.returnConfirmTime;
      }
      if (this.returnInfo.returnReason) {
        this.returnReason = JSON.parse(this.returnInfo.returnReason);
        if (this.returnReason.list && this.returnReason.list.length) {
          this.returnReason.list.forEach((v) => {
            this.statusList.forEach((o) => {
              if (v.status === o.value) {
                v.statusLabel = o.label;
              }
            });
          });
          this.returnReason.list = JSON.parse(
            JSON.stringify(this.returnReason.list)
          );
        }
        console.log("this.returnReason:", this.returnReason);
      }
    },
    
    getRowSpan() {
      this.rowSpanArr = [];
      this.returnGoods.forEach((item, index) => {
        if (index == 0) {
          this.rowSpanArr.push(1);
          this.position = 0;
        } else {
          if (
            this.returnGoods[index].prepayMoney ==
            this.returnGoods[index - 1].prepayMoney
          ) {
            this.rowSpanArr[this.position] += 1; //项目名称相同，合并到同一个数组中
            this.rowSpanArr.push(0);
            this.returnGoods[index].prepayMoney = this.returnGoods[
              index - 1
            ].prepayMoney;
          } else {
            this.rowSpanArr.push(1);
            this.position = index;
          }
        }
      });
    },
  },
};
</script>
 
<style lang='scss' scoped>
.wrap {
  .tab-wrap {
    margin-bottom: 10px;
    padding: 18px 30px;
    background: #fff;
  }
  .content-wrap {
    background: #fff;
    padding: 20px 30px;
    .search-wrap {
      margin-bottom: 20px;
    }
  }
}

.info-list,
.logistics-list {
  .title {
    margin-bottom: 20px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
  .text {
    line-height: 28px;
  }
}
</style>
